// extracted by mini-css-extract-plugin
export default {"not-found":"AccTerminated_not-found__WnbW0"};